import React from "react";
import { isEmpty } from "lodash";

export default function BlockMarketDownline({
  isOpen,
  onClose,
  userName,
  getSportData,
  getMarketBlockUserId,
  setSportsListingUpdate,
  setMatchStatus,
  setMatchBlockStatusToggle,
  setSportsListingUpdateId,
}) {
  if (!isOpen) return null;

  const closeModal = () => onClose?.();

  const handleToggle = (item) => {
    setSportsListingUpdate({
      status: item?.status === "active" ? "inActive" : "active",
      userId: getMarketBlockUserId,
    });
    setMatchStatus(item?.status === "active" ? "InActive" : "Active");
    setMatchBlockStatusToggle();
    setSportsListingUpdateId(item?._id);
  };

  return (
    <div
      id="createModal"
      className="pop_bg"
      style={{ height: "100%", width: "100%", display: "block" }}
      onClick={closeModal}
    >
      <div className="pop_box pop_refer" onClick={(e) => e.stopPropagation()}>
        <a
          href="#"
          className="close_pop"
          onClick={(e) => {
            e.preventDefault();
            closeModal();
          }}
        >
          close_pop
        </a>

        <h2>User Name : {userName}</h2>
        <h3
          className="modal-header"
          style={{ border: "none", padding: "0", marginBottom: "10px" }}
        >
          Block Market
        </h3>

        <div id="modalid" className="modal-content">
          <div className="status_id">
            <table id="table_log" className="table01">
              <thead>
                <tr>
                  <th width="15%" className="align-L">
                    S.No.
                  </th>
                  <th width="18%">Name</th>
                  <th width="18%">Status</th>
                  <th width="16%">Action</th>
                </tr>
              </thead>
              <tbody>
                {getSportData?.data && getSportData.data.length > 0
                  ? getSportData.data.map((item, key) => (
                      <tr key={item?._id || key}>
                        <td className="align-L">{key + 1}</td>
                        <td>
                          <span className="red">
                            <a href="#">{item?.name}</a>
                          </span>
                        </td>
                        <td>
                          {item?.name}{" "}
                          {item?.status === "active" ? "is ON" : "is OFF"}
                        </td>
                        <td title="Status" className="align-C">
                          <label className="xyz">
                            <input
                              type="checkbox"
                              checked={item?.status === "active"}
                              onChange={() => handleToggle(item)}
                            />
                            <span className="slider round" />
                          </label>
                        </td>
                      </tr>
                    ))
                  : isEmpty(getSportData?.data) && (
                      <tr>
                        <td colSpan={4}>No records found</td>
                      </tr>
                    )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
